/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/* @relayHash 45134008e7cf6655e850b0655eba396c */

import { ConcreteRequest } from "relay-runtime";

export type GenerateSignInTokenMutationInput = {
    email: string;
    authRedirectPath?: string | null | undefined;
};
export type SignInScreenTokenFormMutationVariables = {
    input: GenerateSignInTokenMutationInput;
};
export type SignInScreenTokenFormMutationResponse = {
    readonly generateSignInToken: {
        readonly __typename: string;
    };
};
export type SignInScreenTokenFormMutation = {
    readonly response: SignInScreenTokenFormMutationResponse;
    readonly variables: SignInScreenTokenFormMutationVariables;
};



/*
mutation SignInScreenTokenFormMutation(
  $input: GenerateSignInTokenMutationInput!
) {
  generateSignInToken(input: $input) {
    __typename
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "generateSignInToken",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SignInScreenTokenFormMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SignInScreenTokenFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "85433a2a8517c0bbd032c987ee6020d4be5b7318949493fd8edefb15cec1200d",
    "metadata": {},
    "name": "SignInScreenTokenFormMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
(node as any).hash = '4c6e30d6feb1b6d494e7dd857cc165c7';
export default node;
